const maintenancesTab = {
  button: 'ADD NEW MAINTENANCE',
  text: 'NO MAINTENANCE REGISTERED',
  loadMoreButton: 'LOAD MORE',
};

export default maintenancesTab;